import { render, staticRenderFns } from "./forgetAccount.vue?vue&type=template&id=662fd86b&scoped=true"
import script from "./forgetAccount.vue?vue&type=script&lang=js"
export * from "./forgetAccount.vue?vue&type=script&lang=js"
import style0 from "./forgetAccount.vue?vue&type=style&index=0&id=662fd86b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662fd86b",
  null
  
)

export default component.exports